import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";
import common from "./modules/common";
import permission from "./modules/permission";
import settings from "./modules/settings";
import user from "./modules/user";

import projectConfig from "./modules/projectConfig";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    common,
    app,
    settings,
    user,
    projectConfig,
    permission,
  },
  getters,
  state: {},
});

export default store;
